module.exports = __webpack_public_path__ + "img/black_unlock.597ba691.png";